if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;

        // Radios Sim/Não
        this.radioYes = this.querySelector(`#Recipient-choice-yes-${this.sectionId}`);
        this.radioNo  = this.querySelector(`#Recipient-choice-no-${this.sectionId}`);

        // Checkbox legado (permanece oculto; não usamos na lógica nova)
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.sectionId}`);

        // Campos de controle/hidden
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.sectionId}`);
        this.offsetProperty     = this.querySelector(`#Recipient-timezone-offset-${this.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        // Campos do formulário
        this.emailInput   = this.querySelector(`#Recipient-email-${this.sectionId}`);
        this.nameInput    = this.querySelector(`#Recipient-name-${this.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.sectionId}`);
        this.sendonInput  = this.querySelector(`#Recipient-send-on-${this.sectionId}`);
        this.fieldsWrap   = this.querySelector('.recipient-fields');

        // Erros
        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;

        // Variant/contexto
        this.currentProductVariantId = this.dataset.productVariantId;

        // Eventos
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.cartErrorUnsubscriber) this.cartErrorUnsubscriber();
      }

      onChange() {
        const wantsToSendToRecipient = this.radioYes?.checked === true;

        // Espelha o estado no checkbox legado (opcional, para CSS antigo que escutava :checked)
        if (this.checkboxInput) this.checkboxInput.checked = !!wantsToSendToRecipient;

        if (wantsToSendToRecipient) {
          this.enableInputFields();
          this.fieldsWrap.hidden = false;
          if (this.hiddenControlField) this.hiddenControlField.disabled = false; // envia if_present
          if (this.offsetProperty) this.offsetProperty.disabled = false;
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.fieldsWrap.hidden = true;
          if (this.hiddenControlField) this.hiddenControlField.disabled = true;
          if (this.offsetProperty) this.offsetProperty.disabled = true;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput].filter(Boolean);
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty].filter(Boolean);
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        if (!this.errorMessageWrapper) return;
        this.errorMessageWrapper.hidden = false;

        if (typeof body === 'object') {
          if (this.errorMessage) this.errorMessage.innerText = this.defaultErrorHeader;
          Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
          return;
        }

        if (this.errorMessage) this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        if (!this.errorMessageWrapper) return;
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          if (!inputElement) return;
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        // Reseta para "Não"
        if (this.radioNo) this.radioNo.checked = true;
        if (this.radioYes) this.radioYes.checked = false;
        if (this.checkboxInput) this.checkboxInput.checked = false; // legado
        this.clearInputFields();
        this.clearErrorMessage();
        this.onChange();
      }
    }
  );
}